import HELPER from '@/app/utils/HELPER';
import { updateCurrentSettings } from '@/app/editor/sidebar/utils/gfSnippetSettingLinks';

(function (jQuery) {
  jQuery.gfSegment = function (element, options) {
    const defaults = {
      locked: 'false',
      descript_locked: 'Config in advented',
      title: '',
      addHistory: true,
      onSelected: function (value, $element) {},
      onHistoryAdded: function () {},
    };

    let _dataValue = [];

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;
    let _dataColumns = [];
    let _dataNameColumns = [];
    let _descriptionColumns = [];
    let _multiple = 'false';
    let _disable = 'true';
    let _icon = 'false';

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();

      if ($element.attr('data-multiple')) {
        _multiple = $element.attr('data-multiple');
      }
      if ($element.attr('value')) {
        let dataValue = $element.attr('value');
        if (dataValue) {
          if (_multiple == 'true') {
            dataValue = HELPER.trim(dataValue, ',');
            _dataValue = dataValue.split(',');
          } else {
            _dataValue = dataValue;
          }
        }
      }
      if ($element.attr('data-icon')) {
        _icon = $element.attr('data-icon');
      }
      if ($element.attr('data-columns')) {
        _dataNameColumns = $element.attr('data-columns').split(',');
      }
      if ($element.attr('data-value')) {
        _dataColumns = $element.attr('data-value').split(',');
      }
      if ($element.attr('data-tooltips')) {
        _descriptionColumns = $element.attr('data-tooltips').split(',');
      }
      if ($element.attr('data-disable')) {
        _disable = $element.attr('data-disable');
      }
      _this.setTemplate();
      _this.setButtonSegmentClick();

      $element.on('value-change', function () {
        let value = jQuery(this).val();
        if (value && _multiple == 'true') {
          value = HELPER.trim(value, ',');
          value = value.split(',');
        }
        _this.setValue(value);
      });
      return false;
    };

    const _renderItem = function (value, name, index) {
      const width = 100 / _dataColumns.length;
      if (_descriptionColumns.length > 0) {
        if (_icon == 'true') {
          var html =
            '<div data-value="' +
            value +
            '" class="gfSegmentItem" style="width:' +
            width +
            '%" data-tooltips="' +
            _descriptionColumns[index] +
            '" ><i class="' +
            name +
            '"></i></div>';
        } else {
          var html =
            '<div data-value="' +
            value +
            '" class="gfSegmentItem" style="width:' +
            width +
            '%" data-tooltips="' +
            _descriptionColumns[index] +
            '" >' +
            name +
            '</div>';
        }
      } else {
        if (_icon == 'true') {
          var html =
            '<div data-value="' +
            value +
            '" class="gfSegmentItem" style="width:' +
            width +
            '%" ><i class="' +
            name +
            '"></i></div>';
        } else {
          var html =
            '<div data-value="' + value + '" class="gfSegmentItem" style="width:' + width + '%" >' + name + '</div>';
        }
      }
      return html;
    };

    this.onChangeValue = function (type) {
      if (_multiple == 'false') {
        $element.val(_dataValue).attr('value', _dataValue);
        if (type == 'change') {
          _this.settings.onSelected(_dataValue, $element);
        }
      } else {
        let value = '';
        for (let i = 0; i < _dataValue.length; i++) {
          value += _dataValue[i] + ',';
        }
        $element.val(value).attr('value', value);
        if (type == 'change') {
          _this.settings.onSelected(value, $element);
        }
      }
      if (type == 'change') {
        if (!_this.settings.addHistory) {
          _this.settings.onHistoryAdded();
        }

        $element.trigger('input-change').trigger('history-change').trigger('on-require');
        updateCurrentSettings($element.attr('id'), $element.val());
      } else {
        $element.trigger('on-require');
        updateCurrentSettings($element.attr('id'), $element.val());
      }
    };

    this.setTemplate = function () {
      let html = '';
      const $iconLock = jQuery(
        '<div class="gfRangePickerIconLock"><svg fill="#FFC439" height="14px" viewBox="0 0 24 24" width="14px" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg></div>',
      );
      for (let i = 0; i < _dataColumns.length; i++) {
        html += _renderItem(_dataColumns[i], _dataNameColumns[i], i);
      }
      let desc = '';
      if ($element.attr('data-description')) {
        desc = $element.attr('data-description');
      }

      let _template = '<div class="gfSegment">';
      if (_this.settings.title == '') {
        _template += '<div class="gfSGSubTitle" data-title="none">' + _this.settings.title + '</div>';
        _template += '<div class="gfSGclear"></div>';
      } else {
        _template += '<div class="gfSGSubTitle">';
        _template += '<div class="gfSGclear"></div>';
        _template += _this.settings.title;
        if ($element.attr('data-locked') == 'true') {
          _template += $iconLock;
        }
        _template += '</div>';
      }
      _template += '<div class="gfSegmentContent">' + html + '</div>';
      _template += '<div class="gfDesc">' + desc + '</div>';
      _template += '</div>';

      $element.after(_template);
      _this.setValue(_dataValue);

      $iconLock.off('mouseover.tt').on('mouseover.tt', function () {
        $iconLock.gfTooltips();
        const descLocked =
          typeof $element.attr('data-descLocked') !== undefined
            ? $element.attr('data-descLocked')
            : 'Config in advancted';
        $iconLock.data('gftooltips').show($iconLock, descLocked);
      });

      return false;
    };

    this.setButtonSegmentClick = function () {
      const $gfSegment = $element.next();
      // Callback on Click
      const $buttonSegmentClick = $gfSegment.find('.gfSegmentItem');
      $buttonSegmentClick.off('click').on('click', function () {
        const $this = $(this);
        const value = $this.attr('data-value');

        if ($this.hasClass('active')) {
          if (_disable == 'true') {
            if (_multiple == 'true') {
              var index = _dataValue.indexOf(value);
              if (index >= 0) {
                $this.removeClass('active');
                _dataValue.splice(index, 1);
              }
            } else {
              $this.removeClass('active');
              _dataValue = '';
            }
            _this.onChangeValue('change');
          }
        } else {
          if (_multiple == 'true') {
            var index = _dataValue.indexOf(value);
            if (index >= 0) {
              $this.removeClass('active');
              _dataValue.splice(index, 1);
            } else {
              if (!Array.isArray(_dataValue)) {
                _dataValue = [];
              }
              _dataValue.push(value);
              $this.addClass('active');
            }
          } else {
            $buttonSegmentClick.removeClass('active');
            _dataValue = value;
            $this.addClass('active');
          }
          _this.onChangeValue('change');
        }
      });

      if ($element.attr('data-tooltips')) {
        $buttonSegmentClick.off('mouseover.tt').on('mouseover.tt', function () {
          $(this).gfTooltips();
          $(this).data('gftooltips').show($(this), $(this).attr('data-tooltips'));
        });
      }
    };

    this.setValue = function (value) {
      const $gfSegment = $element.next();
      if (_multiple == 'true') {
        _dataValue = value;
        $gfSegment.find('.gfSegmentItem').removeClass('active');
        for (let i = 0; i < _dataValue.length; i++) {
          $gfSegment.find('.gfSegmentItem[data-value="' + _dataValue[i] + '"]').addClass('active');
        }
      } else {
        $gfSegment.find('.gfSegmentItem').removeClass('active');
        _dataValue = value;
        $gfSegment.find('.gfSegmentItem[data-value="' + value + '"]').addClass('active');
      }
      //Change display;
      _this.onChangeValue('set');
    };

    this.clearValue = function () {
      _this.setValue('');
      $element.trigger('input-change').trigger('history-change').trigger('on-require');
      updateCurrentSettings($element.attr('id'), value);
    };

    this.init();
  };
  jQuery.fn.gfSegment = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfsegment')) {
        const plugin = new jQuery.gfSegment(this, options);
        jQuery(this).data('gfsegment', plugin);
      }
    });
  };
})(jQuery);
